import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import validations from '@/plugins/validations'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.use(validations);
Vue.use(VueClipboard);


new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
